import React from 'react'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import { APP_URL, useAuth } from 'shared'

export function MenuInner() {
  const { currentUser } = useAuth()

  return (
    <>
      {currentUser && currentUser.roles?.indexOf('Orders') !== -1 && 
        <MenuItem title='Задачи' to={APP_URL.ORDERS_INDEX} />
      }
      {currentUser && currentUser.roles?.indexOf('Payments') !== -1 && 
        <MenuItem title='Платежи' to={APP_URL.PAYMENTS_INDEX} />
      }
      {currentUser && 
        (currentUser.roles?.indexOf('Stats') !== -1 ||
         currentUser.roles?.indexOf('Moderator') !== -1 ||
         currentUser.roles?.indexOf('Hartiya') !== -1
        ) && 
        <MenuInnerWithSub title='Организация' to='/org/' menuPlacement='bottom-start' menuTrigger='click' >
          {currentUser.roles?.indexOf('Stats') !== -1 && 
            <>
              <MenuItem
                icon="faceid" 
                to={APP_URL.CUSTOMERS_INDEX}
                title='Жертвователи'
              />
              <MenuItem
                icon="chart-line-up-2" 
                to={APP_URL.STATS_INDEX}
                title='Статистика'
              />
              <MenuItem
                icon="sms" 
                to={APP_URL.MAILINGLIST_DRAFT}
                title='Рассылки'
              />
            </>
            // <MenuInnerWithSub 
            //   title='Статистика' 
            //   icon='chart-line-up-2'
            //   to='/org/stats' 
            //   hasArrow={true}
            //   menuPlacement='right-start'
            //   menuTrigger={`{default:'click', lg: 'hover'}`}
            // >
            //   {/* PAGES */}
            //   <MenuItem
            //     hasBullet={true}
            //     to={APP_URL.STATS_INDEX}
            //     title='Жертвователи'
            //   />
            // </MenuInnerWithSub> 
          }
          {currentUser && currentUser.roles?.indexOf('Moderator') !== -1 && 
            <MenuItem title='Настройки' icon="cube-2" to={APP_URL.MY_ORGANIZATION} />
          }
          {currentUser && currentUser.roles?.indexOf('Hartiya') !== -1 && 
            <MenuItem title='Хартия' icon="delivery" to={APP_URL.HARTIYA_INDEX} />
          }
        </MenuInnerWithSub> 
      }
      {currentUser && currentUser.roles?.indexOf('Admin') !== -1 && 
        <MenuInnerWithSub title='Админ' to='/admin' menuPlacement='bottom-start' menuTrigger='click' >
          {/* PAGES */}
          <MenuItem
            icon='profile-circle'
            to={APP_URL.ADMIN_USERS_INDEX}
            title='Пользователи'
          />
          <MenuItem
            icon='cube-2'
            to={APP_URL.ADMIN_ORGS_INDEX}
            title='Организации'
          />
        </MenuInnerWithSub> 
      }
      
    </>
  )
}
